import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import SecurityMenu from "./SecurityMenu";
import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';
import { NavLink ,Link } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import { scrollToTop } from '../Shared/ScrollOnTop';

function ManageUsers(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [isUpdated, setIsUpdated] = useState(false);

    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);


    useEffect(() => {
        document.title = "Manage Users";

        setIsUpdated(false);
        setLoading(true);
        const dashboardParms = {
           AccessKey: AccessKey,
            UserID: UserID,
MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Members/GetAllUsers',
            headers: {
                'Content-Type': 'application/json'
            },
            data: dashboardParms
        };


        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);
                setTotalRecords(response.data.totalRecords);

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, [pageNo, pageSize, isUpdated]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };


    const isProtectedAdmin = (item) =>
        item.IsPrimaryAdministrator === true || item.IsPrimaryAdministrator === "true";

    const renderLedger = () => {

        if (listOfLedger.length > 0) {
            return (
                listOfLedger.map((item, index) => {
                    const protectedUser = isProtectedAdmin(item);
                    return (
                        <tr key={index}>
                            <td>{item.ID}</td>
                            <td>
                                {item.FullName}
                                {protectedUser ? (
                                    <span className="badge bg-secondary ms-1">Primary admin</span>
                                ) : null}
                            </td>
                            <td>{item.UserName}</td>
                            <td>{item.Selected_Group?.GroupName}</td>
                            <td>
                                {protectedUser ? (
                                    <span className="text-muted small">Protected</span>
                                ) : (
                                <ul className="inline-action" aria-labelledby="dropdownMenuButton1">
                                    <li><Link to={'/Security/EditUser/' + item.ID} className=" green"><i className="ri-edit-line"></i></Link></li>
                                    <li><button type="button" onClick={() => deleteUsers(item.ID)} className="red"><i className="ri-delete-bin-line"></i></button></li>
                                </ul>
                                )}
                            </td>
                        </tr>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colspan="8"><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }

    const deleteUsers = (ID) => {
        const target = listOfLedger.find((u) => u.ID === ID);
        if (target && isProtectedAdmin(target)) {
            toast.error("The primary administrator account cannot be deleted.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }

        const confirm = window.confirm("Are you sure to proceed this action ?")
        if(confirm)
        {

      
        const data = {
           AccessKey: AccessKey,
            UserID: UserID,
MemberType: MemberType,
            ID: ID
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Members/DeleteUser',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    setIsUpdated(true);
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    toast.error(response.data.status_message || "Delete failed.", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            })
            .catch(function () {
                toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
            });
        }
    }

    return (
        <>
            {/* <LoginCheck /> */}
            <SecurityMenu />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to="/Security/SecurityDashboard">Security </Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Manage Users</li>
                                </ol>
                            </nav>
                            <div className="page-title">MANAGE USERS</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="/Security/AddNewUser" className="button button-white button-icon">
                                    Add User
                                    <i className="ri-add-line"></i>
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page-content">
                <div className="container">
                    <div className="card">
                        <div className="card-body">

                            <div>
                                <table className="table table-theme table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                ID
                                            </th>
                                            <th>
                                                Full Name
                                            </th>
                                            <th>
                                                User Name
                                            </th>
                                            <th>
                                                Group
                                            </th>

                                            <th className="text-center">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            loading ?
                                                <tr>
                                                    <td className="text-center" colspan="5">
                                                        <Spinner animation="border" role="status"></Spinner>
                                                    </td>
                                                </tr>
                                                :
                                                <>
                                                    {renderLedger()}


                                                </>

                                        }


                                    </tbody>
                                </table>

                                {
                                    totalRecords > 3 &&
                                    <div className="pagination-wrap">

                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                    <div className="form-group">
                                                        <select className="form-select"
                                                            style={{ width: "100px" }}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value));


                                                            }}>
                                                            <option value="10" selected>10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageUsers;